<template>
  <el-footer height="auto">
    <div class="container-con center-aligned">
      <ul>
        <ol><a target="_blank" href="/pc/PrivacyPolicy">Privacy Policy</a></ol>
        <ol>|</ol>
        <ol><a target="_blank" href="/pc/TermsOfService">Terms and Conditions</a></ol>
        <ol>|</ol>
        <ol><span>Contact us by email:  </span><a href="mailto:info@pokerlovers.net">info@pokerlovers.net</a></ol>
      </ul>
      <p>Copyright @ 2018-2019,Pokerlovers. All Rights Reserved</p>
    </div>
  </el-footer>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-footer {
  background-color: #1d1d1d;
  text-align: center;
  color: #dcdcdc;
  font-size: 14px;
  padding: 38px 10px;
  ul {
    margin: 0px;
    padding: 0px;
    ol {
      display: inline-block;
      padding: 0px 3px;
      a {
        color: #dcdcdc;
        &:hover {
          box-shadow: 0 1px;
        }
      }
    }
  }
  p {
    margin: 10px 0px 0px 0px;
  }
}
</style>
